// utils/maze-generator.js
export function generateRandomMaze(rows, cols) {
  const maze = [];

  for (let i = 0; i < rows; i++) {
    const row = [];
    for (let j = 0; j < cols; j++) {
      // Check if the current cell is on the outer edge of the maze
      if (i === 0 || j === 0 || i === rows - 1 || j === cols - 1) {
        row.push(1); // Set outer walls to 1
      } else {
        row.push(Math.random() < 0.3 ? 1 : 0);
      }
    }
    maze.push(row);
  }

  return maze;
}

export function block_prize(ticker, nonce, quantity, prize_type) {
  // Block enum
  const blockEnum = 0x05;

  // PrizeType enum
  let prizeTypeEnum;
  console.log("PRIZE TYPE");
  console.log(prize_type);
  switch (prize_type) {
    case "None":
      prizeTypeEnum = 0x00;
      break;
    case "Finish":
      prizeTypeEnum = 0x01;
      break;
    case "Normal":
      prizeTypeEnum = 0x02;
      break;
    default:
      throw new Error("Invalid prize_type");
  }

  // Ticker length
  const tickerLength = ticker.length;

  // Ticker string
  const tickerString = Buffer.from(ticker, "utf8").toString("hex");

  // Nonce
  const nonceHex =
    nonce === 0 ? "0".repeat(16) : nonce.toString(16).padStart(16, "0");

  // Quantity length
  const quantityLength = Math.ceil(quantity.toString(16).length / 2);

  // Quantity value
  const quantityHex = quantity.toString(16).padStart(quantityLength * 2, "0");

  // Concatenate all parts
  const hex =
    blockEnum.toString(16).padStart(2, "0") +
    prizeTypeEnum.toString(16).padStart(2, "0") +
    tickerLength.toString(16).padStart(8, "0") +
    tickerString +
    nonceHex +
    quantityLength.toString(16).padStart(8, "0") +
    quantityHex;

  return hex;
}

export function block_hex(block_type) {
  let blockEnum;

  switch (block_type) {
    case "None":
      blockEnum = 0x00;
      break;
    case "Start":
      blockEnum = 0x01;
      break;
    case "Finish":
      blockEnum = 0x02;
      break;
    case "Wall":
      blockEnum = 0x03;
      break;
    case "Trap":
      blockEnum = 0x04;
      break;
    case "Random":
      blockEnum = 0x06;
      break;
    case "Teleport":
      blockEnum = 0x07;
      break;
    case "Key":
      blockEnum = 0x08;
      break;
    case "Door":
      blockEnum = 0x09;
      break;
    default:
      throw new Error("Invalid block_type");
  }

  return blockEnum.toString(16).padStart(2, "0");
}

export function block_key(id) {
  // Block enum for key
  const blockEnum = 0x08;

  // Key id
  const keyIdHex =
    id === 0 ? "0".repeat(16) : id.toString(16).padStart(16, "0");

  // Concatenate all parts
  const hex = blockEnum.toString(16).padStart(2, "0") + keyIdHex;

  return hex;
}

export function block_door(id) {
  // Block enum for door
  const blockEnum = 0x09;

  // Door id
  const doorIdHex =
    id === 0 ? "0".repeat(16) : id.toString(16).padStart(16, "0");

  // Concatenate all parts
  const hex = blockEnum.toString(16).padStart(2, "0") + doorIdHex;

  return hex;
}

export function mazeToMatrixOfBlockTypes(maze, blockTypes) {
  let blockTypeMatrix = [];
  for (let row = 0; row < maze.length; row++) {
    let newRow = [];
    for (let col = 0; col < maze[row].length; col++) {
      newRow.push(blockTypes[maze[row][col]]);
    }
    blockTypeMatrix.push(newRow);
  }
  return blockTypeMatrix;
}

export function mazeToHexString(maze) {
  let hexString = "setMatrix";
  for (let row = 1; row <= maze.length; row++) {
    for (let col = 1; col <= maze[row - 1].length; col++) {
      const block = maze[row - 1][col - 1];
      let blockHex;
      switch (block.type) {
        case "None": // Path
          blockHex = block_hex("None");
          break;
        case "Wall": // Wall
          blockHex = block_hex("Wall");
          break;
        case "Trap": // Trap
          blockHex = block_hex("Trap");
          break;
        case "Reward": // NiftyBit
          blockHex = block_prize(
            block.ticker,
            block.nonce,
            block.quantity,
            block.prizeType
          );
          break;
        case "Player": // Player
          blockHex = block_hex("Start");
          break;
        case "Finish": // Finish
          blockHex = block_hex("Finish");
          break;
        case "Key": // Key
          blockHex = block_key(block.id);
          break;
        case "Door": // Door
          blockHex = block_door(block.id);
          break;
        default:
          throw new Error("Invalid block type");
      }
      hexString += `@${row.toString(16).padStart(2, "0")}@${col
        .toString(16)
        .padStart(2, "0")}@${blockHex}`;
    }
  }
  return hexString;
}
